
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import PostingsApi from '../../../API/shipment/postings-api';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { DateInput, Input, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader } from '../../../components/Basic/Table';
import { H1, Text } from '../../../components/Basic/WrapsStyle';
import { MARKETS_LIST } from '../../Shipments/Shipment';
import CameraLine from './Line';
import styles from './styles.module.scss';

const FILTER = {
  0: 'check_camera_all',
  1: 'check_camera_penalty',
  2: 'check_camera_archive',
};
const SHOPS = {
  ozon: ['Все', 'ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  yandex: ['Все', 'yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  wb: ['Все', 'wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  megamarket: ['Все', 'megamarket1', 'megamarket2'],
};

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '100px', // 6
  '200px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '250px', // 11
  '170px', // 12
  '140px', // 13
  '500px', // 14
];
const CalcMonthAgo = () => {
  const start = new Date();
  start.setTime(start.getTime() - 30 * 24 * 3600000);

  return start;
};

const CalcFeatureTwoDay = () => {
  const start = new Date();
  start.setTime(start.getTime() + 2 * 24 * 3600000);
  return start;
};

const CameraPage = () => {
  const [show, setShow] = useState(50);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [postings, setPostings] = useState({ ids: [], byId: {} });

  const [count, setCount] = useState([]);
  const [countStock, setCountStock] = useState([0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ providerId: '' });
  const [checkAll, setCheckAll] = useState(false);

  const allProviders = useSelector((store) => store.providers);

  const [map, setMap] = useState({});
  const [marketMany, setMarketMany] = useState(MARKETS_LIST[0]);
  const [shopName, setShopName] = useState('Все');
  const [providers, setProviders] = useState([]);

  const [period, setPeriod] = useState({ start: CalcMonthAgo(), end: CalcFeatureTwoDay() });

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_select = {};
      postings.ids.forEach((item) => {
        map_select[postings.byId[item].posting_number] = true;
      });
      setProductsSelect(map_select);
      setCheckAll(true);
    } else {
      setCheckAll(false);
      setProductsSelect({});
    }
  };

  const [productsSelect, setProductsSelect] = useState({});

  const user = useSelector((store) => store.user);

  const params = useMemo(() => {
    const shop_name = shopName === 'Все' ? '' : shopName;

    return {
      search: search.trim(),
      market: marketMany === 'Не выбрана' ? undefined : marketMany.toLowerCase(),
      shop: shop_name,
      providerId: provider.id,
      limit: parseInt(show),
      page,
      period: {
        startDate: period.start,
        endDate: period.end,
      },
      tab: FILTER[tab],
    };
  }, [search, show, page, tab, provider.id, marketMany, shopName, period]);

  const loadCards = () => {
    PostingsApi.getCheckCamera({ data: params }).then((r) => {
      const { check_camera_all, check_camera_penalty, check_camera_archive } = r.all_count;

      const byIds = {};
      const id = r.postings.map((item) => item.posting_number);
      r.postings.forEach((item) => (byIds[item.posting_number] = item));

      setPostings({ byId: byIds, ids: id });
      setMap(r.cardsMap);
      setProductsSelect({});
      setCheckAll(false);
      setCountStock([check_camera_all, check_camera_penalty, check_camera_archive]);

      setCount(r.count);
    });

    return () => { };
  };

  const onChangeProduct = async (id, productId, field, value, action = undefined) => {
    await PostingsApi.changeProductInPosting({ data: { postingNumber: id, productId, field, value, action } }).then((r) => {
      setPostings({ ...postings, byId: { ...postings.byId, [r.posting.posting_number]: r.posting } });
    });
    loadCards();
  };

  useEffect(() => {
    loadCards();
  }, [params]);

  const onChangeTab = (n) => {
    setTab(n);
  };

  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  const isOwner = user.role === 'owner' || user.role === 'admin';
  const isAdmin = isOwner || user.role === 'user';

  return (
    <Content>
      <H1>Запросы на камеру</H1>

      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={['Ожидает проверки', 'Штрафы', 'Архив']}
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />
          <Row></Row>
        </Row>

        <Row className={styles.row_input}>
          {Object.keys(productsSelect).length > 0 ? (
            <Row className={styles.row_select}>
              <Row>
                <Button
                  type={TYPE_BUTTONS.RED}
                  style={{ marginRight: '15px' }}
                  onClick={() => {
                    setCheckAll(false);
                    setPostingsPrint({});
                  }}
                >
                  Очистить выбор
                </Button>
              </Row>
            </Row>
          ) : (
            <Input value={search} onBlur={(v) => setSearch(v)} onClickEnter={(v) => setSearch(v)} label="Поиск" />
          )}
        </Row>
        <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>
        <Row spaceBetween={true}>
          <Row style={{ height: '40px' }}>
            <div>
              <Select
                label="Показать на странице"
                select={show}
                list={['20', '50', '100', '150', '200', '500', '1000']}
                onSelect={(v) => setShow(v)}
                width="150px"
                style={{ marginRight: '15px' }}
              />
            </div>

            <Select
              list={MARKETS_LIST}
              select={marketMany}
              label="Площадка"
              onSelect={(v) => setMarketMany(v)}
              width={'150px'}
              style={{ marginRight: '15px' }}
            />
            <Select
              list={SHOPS[marketMany.toLowerCase()] || []}
              select={shopName}
              disabled={marketMany === MARKETS_LIST[0]}
              label="Магазин"
              onSelect={(v) => setShopName(v)}
              width={'150px'}
              style={{ marginRight: '15px' }}
            />
            <Select
              label="Поставщик"
              select={provider}
              valueFn={(p) => p.name}
              list={providers}
              width="200px"
              onSelect={(v) => changeProvider(v)}
              style={{ marginRight: '15px' }}
            />
          </Row>

          <Row>
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Начало периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput
                  value={period.start}
                  className={styles.calendar}
                  onChange={(v) => setPeriod({ ...period, start: new Date(v) })}
                />
              </Row>
            </Column>
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Конец периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput
                  value={period.end}
                  className={styles.calendar}
                  onChange={(v) => setPeriod({ ...period, end: new Date(v) })}
                />
              </Row>
            </Column>
          </Row>
        </Row>
      </WhiteBlock>
      <Table styles={styles.table}>
        <TableHeader whiteHeader>
          <HeaderTitle width={WIDTH_POSTING[0]}>Номер заказа</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
            Дата отгрузки
          </HeaderTitle>

          <HeaderTitle width={WIDTH_POSTING[1]}>Позиции в заказе</HeaderTitle>

          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
            Причина проверки
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[11]} centerText={true}>
            Коммент скк
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[11]} centerText={true}>
            Ответ
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[11]} centerText={true}>
            Разбор полетов
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[3]} centerText={true}>
            Статус
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[14]} centerText={true} />
          <HeaderTitle width={WIDTH_POSTING[1]} centerText={true}>
            Фото
          </HeaderTitle>
        </TableHeader>
        {postings.ids.map((order) => {
          return (
            <CameraLine
              isAdmin={isAdmin}
              tab={tab}
              order={postings.byId[order]}
              map={map}
              key={postings.byId[order].posting_number}
              onChangeProduct={onChangeProduct}
              loadCards={loadCards}
            />
          );
        })}
      </Table>
    </Content>
  );
};

export default CameraPage;
